import React from "react"
import App from "theme/base/App"
import "./theme.scss"
import shop from "shop/shop";
import { Message } from "semantic-ui-react";

shop.config.variantNames = ["Variante"]

shop.config.topNotification = {
  text: "Jetzt Neu: Ihre individualisierten Artikel im Shop",
  cta: "Jetzt ansehen",
  to: "/collection/persArt/?sort=des"
}

shop.config.usePostOrderNotification = function PostOrderNotification() {
  return <div className="PostOrderNotification">
    <Message>
      <Message.Header>{translate("Vielen Dank, Ihre Bestellung wurde erfolgreich übermittelt.")}</Message.Header>
      <div className="pt2" dangerouslySetInnerHTML={{ __html: translate("POST_ORDER_NOTIFICATION") }}/>
    </Message>
    <div className="pt2 pb3">
      <a href="/">
        <button className="Button Button--primary" type="button"><i aria-hidden="true" className="chevron left icon"></i>{translate("zurück zum Shop")}</button>
      </a>
    </div>
  </div>
}
export default App


// WEBPACK FOOTER //
// ./src/theme/orfix-test/App.js